import TabDrawer from '../Reusable/TabDrawer';
import { useEffect, useState } from 'react';
import { SettingIcon } from '../../assets/components/svgs';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { setURLPaths } from '../../app/organizationReducer';
import { RouteConstants } from '../../constants/RouteConstants';
import { HTTP_STATUS } from '../../http/constants/http.status';
import { useTranslation } from 'react-i18next';
import OauthClientTypeSettings from './OauthClientTypeSettings';
import { getOauthTokenSettings } from '../../http/user-management-services';
import LoaderContainer from '../shared/loaderContainer/LoaderContainer';
import Modal from '../shared/ModalPortal/Modal';
import ActionButtons from './ActionButtons';

import { clone, filter, find, unionBy } from 'lodash';
import PickList, { PICKLIST_TYPES } from '../shared/Fields/PickList';
import Card from '../shared/cards/Card';

interface AccessManagementProps {
  defaultTab?: string;
}

const OauthTokenSettings = ({ defaultTab }: AccessManagementProps) => {
  const { t } = useTranslation();
  const queryParams = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [oauthClientData, setOauthClientData] = useState([]);
  const [isReadOnly, setIsReadOnly] = useState(true);

  const [oauthSelectedClient, setOauthSelectedClient] = useState<any>([
    {
      clientName: 'portal_client'
    }
  ]);
  //const [oauthSelectedClient, setOauthSelectedClient] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPickListClient, setSelectedPickListClient] = useState([
    {
      clientName: 'portal_client'
    }
  ]);
  const [showSelectClientModal, setShowSelectClientModal] = useState(false);
  const [activeTab, setActiveTab] = useState(queryParams.client || 'portal-client');
  const [tabConfig, setTabConfig] = useState<any>([]);
  const [initialData, setInitialData] = useState([]);

  const tabPaths: any = {
    'portal-client': '/security-settings/oauth/portal-client',
    'mobile-client': '/security-settings/oauth/mobile-client',
    'oidc-pkce': '/security-settings/oauth/oidc-pkce',
    'service-account-client': '/security-settings/oauth/service-account-client'
  };

  const getOauthClientData = (oauthClientData: any, clientType: any) => {
    return find(oauthClientData, { clientName: clientType });
  };

  useEffect(() => {
    const init = async () => {
      const oauthTokenSettingsResp = await getOauthTokenSettings();
      if (oauthTokenSettingsResp.status === HTTP_STATUS.HTTP_OK) {
        const oauthClientDataResp = oauthTokenSettingsResp.data.data;
        setOauthClientData(oauthClientDataResp);
        setInitialData(oauthClientDataResp);
        //updateTabConfig(oauthClientDataResp);
        setIsLoading(false);
        setShowSelectClientModal(true);
      }
    };
    dispatch(
      setURLPaths([
        {
          key: RouteConstants.ROUTE_SECURITY_SETTINGS_OAUTH,
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        },
        {
          key: '/security-settings/oauth/portal-client',
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        },
        {
          key: '/security-settings/oauth/mobile-client',
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        },
        {
          key: '/security-settings/oauth/oidc-pkce',
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        },
        {
          key: '/security-settings/oauth/service-account-client',
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        }
      ])
    );
    setIsLoading(true);
    init();
  }, []);

  const ChangeTab = (tab: string) => {
    navigate(tabPaths[tab]);
    setActiveTab(tab);
  };

  const updateOauthClientData = (data: any) => {
    const { clientName } = data;
    const clonedOauthClientData = clone(oauthClientData);
    const updatedOauthData: any = clonedOauthClientData.map((obj: any) =>
      obj.clientName === clientName ? data : obj
    );
    setOauthClientData(updatedOauthData);
  };

  return (
    <LoaderContainer isLoading={isLoading}>
      {oauthClientData.length && oauthSelectedClient.length ? (
        <OauthClientTypeSettings
          key={JSON.stringify(oauthSelectedClient[0]?.clientName)}
          formData={getOauthClientData(oauthClientData, oauthSelectedClient[0]?.clientName)}
          clientName={oauthSelectedClient[0]?.clientName}
          updateOauthClientData={updateOauthClientData}
          oauthSelectedClient={oauthSelectedClient}
          setOauthSelectedClient={setOauthSelectedClient}
          oauthClientData={oauthClientData}
          setIsReadOnly={setIsReadOnly}
          isReadOnly={isReadOnly}
        />
      ) : (
        ''
      )}
    </LoaderContainer>
  );
};

export default OauthTokenSettings;
